// eslint-disable-next-line jira/restricted/react-18
import { useSyncExternalStore } from 'react';

/**
 * True if we're rendering on the client and hydration has completed (or we aren't hydrating).
 * Always false on the server.
 * @see https://tkdodo.eu/blog/avoiding-hydration-mismatches-with-use-sync-external-store
 */
export const useIsClientReady = (): boolean =>
	useSyncExternalStore(
		() => () => {
			// empty
		},
		() => true,
		() => false,
	);
